import React from 'react';
import PropTypes from 'prop-types';
import { Button, SplitButton } from 'framework-ui-components/Components/V2';
import AddIcon from 'framework-ui-components/Components/GoogleIcons/Outlined/AddIcon';

const AzioniCreaDomanda = (props) => {
  const {
    servizioAttivo,
    avviaCreazioneDichiarazioneOrdinaria,
    avviaCreazioneDichiarazioneVariazione,
    avviaCreazioneDichiarazioneArretrata,
    annoCampagna,
    dichiarazioniSelezionate = [],
  } = props;
  return servizioAttivo
    && !dichiarazioniSelezionate.length
    && (
      <SplitButton primary onClick={() => avviaCreazioneDichiarazioneOrdinaria()}>
        <AddIcon />Crea domanda {annoCampagna}
        <SplitButton.DropdownList>
          <Button onClick={() => avviaCreazioneDichiarazioneVariazione()}>
            <span>Crea variazione {annoCampagna}</span>
          </Button>
          <Button onClick={() => avviaCreazioneDichiarazioneArretrata()}>
            <span>Crea domanda anni precedenti</span>
          </Button>
        </SplitButton.DropdownList>
      </SplitButton>
    );
};

AzioniCreaDomanda.propTypes = {
  servizioAttivo: PropTypes.bool.isRequired,
  avviaCreazioneDichiarazioneOrdinaria: PropTypes.func.isRequired,
  avviaCreazioneDichiarazioneVariazione: PropTypes.func.isRequired,
  avviaCreazioneDichiarazioneArretrata: PropTypes.func.isRequired,
};

export default AzioniCreaDomanda;
